import React from 'react';
import '../styles/App.scss';

const Loader = () => {
  const letters = ['N', 'I', 'R', 'M', 'A', 'L', '', 'D', 'H', 'A', 'K', 'A', 'L'];

  return (
    <div className="loader-container" id="loader">
      <div className="name-loader">
        {letters.map((letter, index) => (
          <div 
            key={index} 
            className="letter" 
            style={{ '--delay': `${index * 0.1}s` }}
          >
            {letter}
          </div>
        ))}
      </div>
      <div className="loader-subtitle">Here We Go</div>
    </div>
  );
};

export default Loader;